import jrGdprModalTemplate from '../../view/angular/common/modal/gdpr-modal.tpl.html';
import { JtagService } from '../../ts/service/jtag-service.ts';

angular
  .module('jrModal', ['jrConfig', 'jrEvents'])
  .value('jrGdprModalTemplate', jrGdprModalTemplate)
  .factory('ModalProposalService', [
    '$modal',
    'ModalConfig',
    function ($modal, ModalConfig) {
      function openModal(modalOptions) {
        modalOptions.backdropClass = `opacity-${ModalConfig.overlayOpacity}`;
        return $modal.open(modalOptions);
      }

      return {
        openModal,
      };
    },
  ])
  .directive('jrGdprModal', [
    'ModalProposalService',
    'Messages',
    '$rootScope',
    '$http',
    'JobseekerConfig',
    'jrGdprModalTemplate',
    function (
      ModalProposalService,
      Messages,
      $rootScope,
      $http,
      JobseekerConfig,
      jrGdprModalTemplate
    ) {
      return {
        link(scope) {
          scope.messages = Messages;
          scope.gdprModalError = false;
          $rootScope.gdprModalEnabled = true;
          scope.isAlreadyClicked = false;

          scope.openGdprModal = ModalProposalService.openModal({
            template: jrGdprModalTemplate,
            windowClass: 'gdpr-modal',
            backdrop: 'static',
          });

          scope.closeModal = function (event) {
            if (!scope.isAlreadyClicked) {
              scope.isAlreadyClicked = true;
              $http
                .get('/privacy-policy/change', {
                  params: {
                    jobseeker_id: JobseekerConfig.id,
                    from: 'banner',
                    core_services_accepted: true,
                    job_marketing_accepted: true,
                  },
                })
                .then(
                  function (response) {
                    JtagService.trackPrivacyPolicyAcceptClient(event);

                    scope.openGdprModal.close();
                    $rootScope.gdprModalEnabled = false;
                    scope.gdprModalError = false;
                  },
                  function (response) {
                    scope.gdprModalError = true;
                    scope.isAlreadyClicked = false;
                  }
                );
            }
          };
          JtagService.trackPrivacyPolicyImpressionClient();
        },
      };
    },
  ]);
